<template>
   <!-- 认证图标 -->
   <div class="r_img"
        :class="PdftStore.fromData.questionnaireInfo?.grade == 1
        ? 'qingtong_logo'
        : PdftStore.fromData.questionnaireInfo?.grade == 2
        ? 'baiyin_logo'
        : PdftStore.fromData.questionnaireInfo?.grade == 3
        ? 'huangjin_logo'
        : PdftStore.fromData.questionnaireInfo?.grade == 4
        ? 'baijin_logo'
        : PdftStore.fromData.questionnaireInfo?.grade == 5
        ? 'zuanshi_logo'
        : ''
        "
   >
        <div class="img_txt">
            <div class="txt_y">{{formatDateTimeYYs(PdftStore.fromData.questionnaireInfo?.evaluationDate)}}</div>
            <div class="top">Top</div>
            <div class="txt_n">{{PdftStore.fromData.questionnaireInfo?.top ? PdftStore.fromData.questionnaireInfo?.top : 0}}%</div>
            <RadianText :name="ids"/>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
import RadianText from '@/components/radianText.vue'
export default {
    name: 'logos',
    props:{
        ids:{
            type:String,
            default:"",
        }
    },
    components:{RadianText},
    setup(props) {
        const data = reactive({
            ids:props.ids
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.qingtong_logo{
    background: url('@/assets/img/report_qingtong_logo_en.png');
}
.baiyin_logo{
    background: url('@/assets/img/report_baiyin_logo_en.png');
}
.huangjin_logo{
    background: url('@/assets/img/report_huangjin_logo_en.png');
}
.baijin_logo{
    background: url('@/assets/img/report_baijin_logo_en.png');
}
.zuanshi_logo{
    background: url('@/assets/img/report_zuanshi_logo_en.png');
}
.r_img{
    width: 300px;
    height: 300px;
    background-repeat: no-repeat;
    background-size: cover;
    .img_txt{
        position: relative;
        .txt_y{
            font-size: 14px;
            line-height: 0;
            color: #FFFFFF;
            position: absolute;
            top: 110px;
            left: 21px;
            transform: rotateZ(29deg);
        }
        .txt_c{
            font-size: 38px;
            font-weight: 600;
            position: absolute;
            top: 80px;
            left: 90px;
            color: #00DF9F;
        }
        .top{
            font-size: 14px;
            line-height: 0;
            color: #FFFFFF;
            position: absolute;
            top: 170px;
            right: 17px;
            transform: rotateZ(27deg);
        }
        .txt_n{
            font-size: 14px;
            line-height: 0;
            font-weight: 600;
            color: #FFFFFF;
            position: absolute;
            // top: 165px;
            // right: 17px;
            top: 190px;
            right: 22px;
            transform: rotateZ(30deg);
        }
    }
}
</style>